module.exports = __webpack_public_path__ + "static/img/noprize.fb1bb3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noprize.png
// module id = d/zW
// module chunks = 1